export enum ReportsApiUrl {
  ProfitAndLoss = 'incomeStatement',
  Balance = 'balanceSheet',
  TrialBalance = 'trialBalance',
}
